export default "__VITE_ASSET__3N2nT2S9__"